import { api } from './client'

export interface LoginRequest {
    username: string
    password: string
}

export interface LoginResponse {
    user: {
        id: string
        username: string
        full_name: string
        is_active: boolean
    }
    expires_at: string
}

export interface ImpersonationIdentity {
    id: string
    username: string
}

export interface MeResponse {
    user_id: string
    username: string
    full_name?: string
    permissions?: string[]
    // Present only while an admin is viewing as another user. The user_id /
    // username / permissions above are the EFFECTIVE (target) user; this block
    // exposes both identities.
    impersonating?: {
        actor: ImpersonationIdentity
        target: ImpersonationIdentity
    } | null
}

export const authApi = {
    login: (data: LoginRequest) => api.post<LoginResponse>('/auth/login', data),

    logout: () => api.post<{ message: string }>('/auth/logout'),

    refresh: () => api.post<LoginResponse>('/auth/refresh'),

    me: () => api.get<MeResponse>('/auth/me'),

    // changePassword: backend route not implemented yet
    // changePassword: (data: { current_password: string; new_password: string }) =>
    //     api.put<{ message: string }>('/auth/change-password', data),
}
